package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantStaffItemResponse

data class StaffListUIState(
    val staff: List<MerchantStaffItemResponse> = emptyList(),
    val locations: List<MerchantLocationResponseModel> = emptyList(),
    /** null = "All locations", otherwise filter staff by this location id */
    val selectedLocationId: Long? = null,
    val filteredStaff: List<MerchantStaffItemResponse> = emptyList(),
    val isLoading: Boolean = false
)
